import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { SceneInfo } from '../../types/scene.types';

export interface UseAutoFillLocationOptions {
  sceneInfo: SceneInfo | null;
  onUpdateLocation: (location: string) => void;
  onUpdateDisplayText?: (location: string) => void;
}

export interface UseAutoFillLocationReturn {
  checkAndAutoFillLocation: (sceneSetValue: string) => void;
}

export const useAutoFillLocation = (options: UseAutoFillLocationOptions): UseAutoFillLocationReturn => {
  const { t } = useTranslation();
  const { sceneInfo, onUpdateLocation, onUpdateDisplayText } = options;

  const checkAndAutoFillLocation = useCallback(
    (sceneSetValue: string) => {
      if (!sceneInfo) return;

      const currentLocation = sceneInfo.sceneLocation;
      const isLocationEmpty = !currentLocation || currentLocation.trim() === '';

      if (isLocationEmpty && sceneSetValue && sceneSetValue.trim() !== '') {
        const prefix = t('breakdown.autoFillLocationPrefix');
        const autoLocation = `${prefix}${sceneSetValue.trim()}`;
        onUpdateLocation(autoLocation);
        if (onUpdateDisplayText) onUpdateDisplayText(autoLocation);
      }
    },
    [sceneInfo, onUpdateLocation, onUpdateDisplayText, t],
  );

  return { checkAndAutoFillLocation };
};

